import { defineStore } from "pinia";
import { ref } from "vue";
import { IGroupTemplate } from "../models/groupTemplate";
import GroupTemplateService from "../services/GroupTemplateService";
import { useUsersStore } from "./users.store";

// Lot9 — Gabarits de groupe (couleur + plage horaire par rang), paramétrage de centre.
// Pas de CRUD unitaire côté API (2 endpoints seulement : GET liste + PUT remplace tout) —
// même pattern que compteurStore.schemaPrefs (chargement/sauvegarde en bloc par centre).
export const useGroupTemplateStore = defineStore("groupTemplates", () => {
  const datas = ref<IGroupTemplate[]>([]);
  const isLoading = ref(false);

  const currentCenterId = () => useUsersStore().currentCenter?.id;

  async function load(centerId?: number) {
    isLoading.value = true;
    const result = await GroupTemplateService.getAll(centerId ?? currentCenterId());
    if (!result.error) datas.value = (result.data as IGroupTemplate[]) ?? [];
    isLoading.value = false;
    return result;
  }

  /** Remplace tous les gabarits du centre (couleur + plage horaire par rang) et resynchronise l'état local. */
  async function save(templates: IGroupTemplate[], centerId?: number) {
    isLoading.value = true;
    const result = await GroupTemplateService.replace(templates, centerId ?? currentCenterId());
    if (!result.error) datas.value = (result.data as IGroupTemplate[]) ?? [];
    isLoading.value = false;
    return result;
  }

  /** Gabarit correspondant à un rang (1..8), ou undefined si non configuré pour ce centre. */
  function getByRank(rank: number): IGroupTemplate | undefined {
    return datas.value.find((t) => t.rank === rank);
  }

  return {
    datas,
    isLoading,
    load,
    save,
    getByRank,
  };
});
